import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { img } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function SearchPage() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const [res, setRes] = useState(null);
  useEffect(() => { if (q) api.get(`/search?q=${encodeURIComponent(q)}`).then(r => setRes(r.data)); }, [q]);

  const empty = res && !res.products?.length && !res.collections?.length && !res.articles?.length;

  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14 min-h-[60vh]">
      <span className="eyebrow text-moss">Search</span>
      <h1 className="serif text-5xl mt-2 mb-10">Results for "{q}"</h1>
      {empty && (
        <div className="py-16 text-center">
          <p className="serif text-3xl text-forest/60 mb-6">Nothing found in this forest.</p>
          <div className="flex gap-4 justify-center"><Link to="/shop" className="btn-outline">Browse Collections</Link><Link to="/collections/best-sellers" className="btn-primary">Best Sellers</Link></div>
        </div>
      )}
      {res?.products?.length > 0 && (
        <><h2 className="serif text-2xl mb-6">Products</h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-12 mb-16">{res.products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}</div></>
      )}
      {res?.articles?.length > 0 && (
        <><h2 className="serif text-2xl mb-6">Journal</h2>
        <div className="grid md:grid-cols-3 gap-8">{res.articles.map(a => (
          <Link key={a.slug} to={`/journal/${a.slug}`} className="group"><div className="overflow-hidden aspect-[4/3] mb-4"><img src={img(a.cover)} alt="" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" /></div><h3 className="serif text-xl">{a.title}</h3></Link>
        ))}</div></>
      )}
    </div>
  );
}
